// eslint-disable-next-line
export const GROWTHBOOK_PROMO_FINANCING = 'promo-financing'

export const GROWTHBOOK_VARIANTS = {
  'complete-your-room': {
    showFinance: 'finance-message-complete-your-room',
  },
  'compare-similar-items': {
    showFinance: 'finance-message-compare-similar-items',
  },
  'select-your-bonus-item': {
    showFinance: 'finance-message-select-your-bonus-item',
  },
  ymal: {
    showFinance: 'finance-message-ymal',
  },
  plp: {
    showFinance: 'finance-message-plp',
  },
  cart: {
    desktop: {
      showFinanceCalculator: 'finance-message-calculator-desktop-cart',
      showFinanceBanner: 'finance-message-banner-desktop-cart',
    },
    mobile: {
      showFinanceCalculator: 'finance-message-calculator-mobile-cart',
      showFinanceBanner: 'finance-message-banner-mobile-cart',
    },
  },
  'strapi-slider': {
    showFinance: 'finance-message-strapi-slider',
  },
  default: { showFinance: '' },
}
